import * as R from "ramda";

import { getCandidateTypes } from "./batchActions";

export function metadataMapper({ metadata, source }) {
  return source === ""
    ? metadata.total
    : source === "false"
    ? metadata.external
    : metadata.registered;
}

export function makeMetadataFromCandidates(candidates) {
  const { internalCandidates, externalCandidates } = getCandidateTypes(
    candidates
  );
  return {
    total: R.length(candidates),
    registered: R.length(internalCandidates),
    external: R.length(externalCandidates)
  };
}

export function generateListWithMetadata(candidates = []) {
  return {
    candidates: candidates,
    metadata: makeMetadataFromCandidates(candidates)
  };
}
